import * as React from 'react';
import type { ApplicationProcessSectionBlockViewModel } from '../ViewModel/ApplicationProcessSectionBlockViewModel.csharp';
import { mapTabs } from '~/Blocks/CardsSectionBlock/View/Utils/CardsSectionBlockUtils';
import { ApplicationProcessSection } from '~/Features/StudyPage/Campus/Sections/ApplicationProcessSection/ApplicationProcessSection';

export const ApplicationProcessSectionBlock: React.FC<ApplicationProcessSectionBlockViewModel> = props => {
    const { tabs, ...otherProps } = props;

    return <ApplicationProcessSection {...otherProps} tabs={mapTabs(tabs)} />;
};
